import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Single source of truth for plan-gated product features. Reads
 * GET /api/workspace/capabilities once and caches it module-wide so every
 * component (New menu, task actions, meeting recorder, pricing) agrees.
 */
let _cache = null;
let _promise = null;

export function refreshCapabilities() {
  _cache = null;
  _promise = null;
}

export function useCapabilities() {
  const [state, setState] = useState(_cache);
  useEffect(() => {
    let alive = true;
    if (_cache) {
      setState(_cache);
      return () => {};
    }
    if (!_promise) {
      _promise = api
        .get("/workspace/capabilities")
        .then((r) => {
          _cache = r.data;
          return r.data;
        })
        .catch(() => ({ capabilities: {}, plan_id: null, plan_name: null }));
    }
    _promise.then((d) => {
      if (alive) setState(d);
    });
    return () => {
      alive = false;
    };
  }, []);

  const capabilities = state?.capabilities || {};
  return {
    capabilities,
    planId: state?.plan_id || null,
    planName: state?.plan_name || null,
    loading: state === null,
    has: (key) => !!capabilities[key],
  };
}
